// Access the strings used on the SendRecoveryPasswordLink ans RecoveryPassword pages.
export const t_SendRecoveryPasswordLink = {
    title: "login.sendRecoveryPasswordLink.title",
    subtitle: "login.sendRecoveryPasswordLink.subtitle",
    text: "login.sendRecoveryPasswordLink.text",
    initialText: "login.sendRecoveryPasswordLink.initialText",
    timeLabel: "login.sendRecoveryPasswordLink.timeLabel",
    linkLabel: "login.sendRecoveryPasswordLink.linkLabel",
    buttonText: "login.sendRecoveryPasswordLink.buttonText",
    buttonWaitText: "login.sendRecoveryPasswordLink.buttonWaitText",
    buttonSendingText: "login.sendRecoveryPasswordLink.buttonSendingText",
    buttonMaxReachedText: "login.sendRecoveryPasswordLink.buttonMaxReachedText",
    cooldownMessage: "login.sendRecoveryPasswordLink.cooldownMessage",
    sendCountMessage: "login.sendRecoveryPasswordLink.sendCountMessage",
    maxSendsMessage: "login.sendRecoveryPasswordLink.maxSendsMessage",
    recoveryLinkSentTitle: "login.sendRecoveryPasswordLink.recoveryLinkSentTitle"
  };

export const t_recoveryPassword = {
    title: "login.recoveryPassword.title",
    subtitle: "login.recoveryPassword.subtitle",
};